import React from 'react';

const HeroSection = ({ className = '' }) => {
  return (
    <section className={`flex flex-col items-center min-h-[174px] w-full px-4 py-8 ${className}`}>
      <div className="flex flex-col items-center max-w-[1201px] w-full gap-4">
        <h3 className="text-[#ef8702] text-base font-extrabold uppercase text-center">
          WHAT WE BELIEVE IN
        </h3>
        <div className="flex flex-col items-center gap-4">
          <h1 className="text-black text-5xl font-extrabold text-center max-w-[1201px]">
            The Transformative Power Of Communication
          </h1>
          <p className="text-black text-base text-center max-w-[1011px]">
            Language is more than words—it's the foundation of connection, culture, and progress. Clear communication creates opportunities, strengthens communities, and enriches cultural exchange.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;

